<template>
  <div
    class="fixed w-full overflow-hidden border-l border-[#dedede] dark:border-[#353843] py-8"
  >
    <div
      class="absolute rounded-full animate-blog filter blur-3xl opacity-30 mix-blend-multiply top-1/2 left-1/2 bg-fire w-72 h-72"
    ></div>
    <div
      class="absolute filter blur-3xl opacity-30 mix-blend-multiply top-12 left-[60px] bg-indigo-700 w-32 h-32 rounded-full"
    ></div>
    <div class="flow-root">
      <div>
        <h2
          class="flex flex-row space-x-4 dark:text-white text-[28px] font-medium items-center"
        >
          <span>
            <svg width="22" height="24" viewBox="0 0 22 24">
              <defs>
                <linearGradient
                  id="linear-gradient"
                  x1="-0.288"
                  y1="0.5"
                  x2="1.307"
                  y2="0.5"
                  gradientUnits="objectBoundingBox"
                >
                  <stop offset="0" stop-color="#ed1b24" />
                  <stop offset="1" stop-color="#f97643" />
                </linearGradient>
              </defs>
              <g id="Document">
                <path
                  id="Document-2"
                  data-name="Document"
                  d="M16.123,24H5.878C2.143,24,0,21.883,0,18.192V5.8A5.829,5.829,0,0,1,1.546,1.526,6.009,6.009,0,0,1,5.878,0H16.123C19.858,0,22,2.113,22,5.8v12.4a5.806,5.806,0,0,1-1.523,4.3A5.954,5.954,0,0,1,16.123,24ZM6.109,16.484a.958.958,0,0,0-.817.449.938.938,0,0,0,0,1.008.966.966,0,0,0,.8.44.871.871,0,0,0,.119-.008h9.583a.946.946,0,0,0,0-1.884H6.208C6.176,16.485,6.142,16.484,6.109,16.484Zm.1-5.469a.937.937,0,1,0,0,1.873h9.583a.937.937,0,1,0,0-1.873Zm0-5.435v.012h0a.935.935,0,1,0,0,1.87H9.863a.942.942,0,1,0,0-1.884Z"
                  fill="url(#linear-gradient)"
                />
              </g>
            </svg>
          </span>
          <span class="tracking-wider">{{ t("input.allq") }}</span>
        </h2>
        <p class="py-2 text-navada"></p>
        <div class="w-full h-[1px] bg-[#cbced2] dark:bg-[#353843] mt-6"></div>
      </div>
      <ul
        role="list"
        class="-mb-8 mt-[20px] h-full pb-[100px] pt-6 overflow-y-auto pr-4"
      >
        <li
          class="cursor-pointer"
          v-for="(item, eventIdx) in items"
          :key="item.id"
          @click="
            current = eventIdx;
            $emit('selection', item, eventIdx);
            $emit('close');
          "
        >
          <div class="relative pb-8">
            <span
              v-if="eventIdx !== items.length - 1"
              class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-[#f0f1f3] dark:bg-[#2f2e37]"
              aria-hidden="true"
            />
            <div class="relative flex items-center space-x-3">
              <div>
                <span
                  :class="[
                    'bg-[#f2f2f2] dark:bg-[#2f2e37]',
                    'h-8 w-8 rounded-full flex items-center justify-center ',
                  ]"
                >
                  <CheckIcon
                    v-if="item.answer"
                    class="h-5 w-5 text-[#ff001c] dark:text-gold"
                  />
                  <ExclamationIcon
                    v-if="item.required && !item.answer"
                    class="h-5 w-5 text-[#ff001c] dark:text-gold"
                  />
                </span>
              </div>
              <div class="flex justify-between flex-1 min-w-0 space-x-4">
                <div class="w-[80%] flex flex-col items-start justify-center">
                  <span
                    :class="[
                      current === eventIdx
                        ? 'text-tolopea dark:text-white'
                        : 'text-[#93909b] dark:text-navada',
                    ]"
                    class="flex-shrink-0 min-w-0 text-base"
                    >{{ eventIdx < 9 ? 0 : "" }}{{ eventIdx + 1 }}</span
                  >
                  <p
                    :class="[
                      current === eventIdx
                        ? 'text-tolopea dark:text-white'
                        : 'text-[#93909b] dark:text-navada',
                    ]"
                    class="text-base font-medium text-[16px] hover:text-fire transition ease-in duration-300"
                  >
                    {{ item.questionDisplay }}
                    <span v-if="item.required" class="text-xl text-ruby"
                      >*</span
                    >
                  </p>
                </div>
                <div
                  class="inline-flex items-center space-x-2 text-sm text-right dark:text-white"
                >
                  <span>{{ t("input.edit") }}</span>
                  <button
                    @click="
                      current = eventIdx;
                      $emit('selection', item, eventIdx);
                      $emit('close');
                    "
                    class="inline-flex rounded-md w-[32px] h-[32px] justify-center items-center focus:outline-none"
                  >
                    <svg
                      class="hidden dark:block"
                      id="Iconly_Bold_Edit_Square"
                      data-name="Iconly/Bold/Edit Square"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        id="Edit_Square"
                        data-name="Edit Square"
                        transform="translate(2 2)"
                      >
                        <path
                          id="Edit_Square-2"
                          data-name="Edit Square"
                          d="M15,20c-.11,0-.222,0-.332-.01H5.335C5.225,20,5.112,20,5,20a5.321,5.321,0,0,1-3.6-1.4A5.371,5.371,0,0,1,.01,14.665V5.335A5.372,5.372,0,0,1,1.4,1.4,5.328,5.328,0,0,1,5,0c.11,0,.221,0,.331.01h9.33c.109-.007.219-.01.328-.01a5.317,5.317,0,0,1,3.6,1.4,5.416,5.416,0,0,1,1.4,3.937v9.33A5.4,5.4,0,0,1,18.6,18.6,5.323,5.323,0,0,1,15,20ZM10.38,6.464a.214.214,0,0,0-.15.059L5.465,11.289a1.8,1.8,0,0,0-.529,1.238L4.875,14.9a.467.467,0,0,0,.13.339.478.478,0,0,0,.34.14H7.692a1.84,1.84,0,0,0,1.289-.53L15.7,8.1a1.586,1.586,0,0,0,0-2.227l-1.3-1.3a1.58,1.58,0,0,0-2.237,0l-.67.68a.265.265,0,0,0,0,.369c.016.016,1.589,1.579,1.618,1.619a.678.678,0,0,1,.18.459.66.66,0,0,1-.659.66.626.626,0,0,1-.44-.18L10.529,6.523A.212.212,0,0,0,10.38,6.464Z"
                          transform="translate(0 0)"
                          fill="#f8d397"
                        />
                      </g>
                    </svg>

                    <svg
                      class="dark:hidden"
                      id="Iconly_Bold_Edit_Square"
                      data-name="Iconly/Bold/Edit Square"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        id="Edit_Square"
                        data-name="Edit Square"
                        transform="translate(2 2)"
                      >
                        <path
                          id="Edit_Square-2"
                          data-name="Edit Square"
                          d="M15,20c-.11,0-.222,0-.332-.01H5.335C5.225,20,5.112,20,5,20a5.321,5.321,0,0,1-3.6-1.4A5.371,5.371,0,0,1,.01,14.665V5.335A5.372,5.372,0,0,1,1.4,1.4,5.328,5.328,0,0,1,5,0c.11,0,.221,0,.331.01h9.33c.109-.007.219-.01.328-.01a5.317,5.317,0,0,1,3.6,1.4,5.416,5.416,0,0,1,1.4,3.937v9.33A5.4,5.4,0,0,1,18.6,18.6,5.323,5.323,0,0,1,15,20ZM10.38,6.464a.214.214,0,0,0-.15.059L5.465,11.289a1.8,1.8,0,0,0-.529,1.238L4.875,14.9a.467.467,0,0,0,.13.339.478.478,0,0,0,.34.14H7.692a1.84,1.84,0,0,0,1.289-.53L15.7,8.1a1.586,1.586,0,0,0,0-2.227l-1.3-1.3a1.58,1.58,0,0,0-2.237,0l-.67.68a.265.265,0,0,0,0,.369c.016.016,1.589,1.579,1.618,1.619a.678.678,0,0,1,.18.459.66.66,0,0,1-.659.66.626.626,0,0,1-.44-.18L10.529,6.523A.212.212,0,0,0,10.38,6.464Z"
                          transform="translate(0 0)"
                          fill="#1b1c20"
                        />
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="absolute z-40 top-4 right-4">
      <button
        @click="$emit('close')"
        class="inline-flex text-white hover:text-fire font-bold outline transition-all text-sm justify-center trans items-center bg-[#dedede] dark:bg-[#31313b] w-[32px] h-[32px] rounded-full"
      >
        X
      </button>
    </div>
  </div>
</template>

<script>
import { CheckIcon, PencilIcon, ExclamationIcon } from "@heroicons/vue/solid";
import { useI18n } from "vue-i18n";

export default {
  components: { CheckIcon, PencilIcon, ExclamationIcon },
  props: {
    current: {
      type: Number,
      required: true,
    },
    items: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
};
</script>
